export enum ColorVariant {
    yellow = 'yellow',
    green = 'green',
    red = 'red',
    blue = 'blue',
    lightBlue = 'lightBlue',
    grey = 'grey',
}
